// src/pages/AboutUs.js

import React from 'react';

const AboutUs = () => {
  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-4xl font-bold text-center mb-8">About Us</h1>

      {/* Mission */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-2">🚀 Mission</h2>
        <p className="text-gray-700">
          Our mission is to empower businesses with cutting-edge digital solutions that are fast, scalable, and user-friendly.
        </p>
      </section>

      {/* Vision */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-2">🌍 Vision</h2>
        <p className="text-gray-700">
          We envision a future where every startup, no matter how small, has access to world-class technology and design.
        </p>
      </section>

      {/* Establishment */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-2">🏢 Establishment</h2>
        <p className="text-gray-700">
          Our company was established in 2023 with the goal of helping startups and small businesses launch powerful digital platforms with ease.
        </p>
      </section>

      {/* Founder */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-2">🧑‍💼 Founder</h2>
        <p className="text-gray-700">
          Founded by Nihal, a passionate software engineer and entrepreneur with a vision to simplify technology for everyone. His experience and leadership drive the company’s innovative spirit.
        </p>
      </section>

      {/* Our Journey */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-2">📈 Our Journey</h2>
        <p className="text-gray-700">
          What started as a small team of dreamers has grown into a full-fledged product development studio. We’ve helped over 50 startups launch successful platforms across various industries.
        </p>
      </section>

      {/* Our Team */}
      <section>
        <h2 className="text-2xl font-semibold mb-2">👨‍💻 Our Team</h2>
        <p className="text-gray-700">
          We are a group of passionate developers, designers, and strategists driven by curiosity and creativity. Together, we bring ideas to life.
        </p>
      </section>
    </div>
  );
};

export default AboutUs;
